import { Courses, CustomFields, EducationCoursesProvider } from '@/contexts/eduadmin';
import { Breadcrumb } from '@/contexts/seo/SeoProvider';
import { DefaultProps, buildGetStaticProps } from '@/server/slug';
import { GetStaticPaths } from 'next';
import { t } from 'ttag';
import { Layout } from '../../bloks/Global';
import { getServerPageConfig } from '../../server/config';
import { fetchAllCourses, fetchCustomFields, getAccessToken } from '../../server/eduadmin/client';

// Component based on Storyblok blog post example
// https://github.com/storyblok/nextjs-multilanguage-website/blob/main/pages/%5B%5B...slug%5D%5D.js

interface Props extends DefaultProps {
	courses: Courses | null;
	subjects: CustomFields | null;
	targetGroups: CustomFields | null;
	educationTypes: CustomFields | null;
}

const Page: React.FC<Props> = ({ ...props }) => {
	return (
		<EducationCoursesProvider
			courses={props.courses!}
			subjects={props.subjects!}
			targetGroups={props.targetGroups!}
			educationTypes={props.educationTypes!}
		>
			<Layout {...props} />
		</EducationCoursesProvider>
	);
};

export default Page;

export const getStaticProps = buildGetStaticProps<Props>({
	initialize(params) {
		if (params.slug) {
			return { notFound: true };
		}
		const pageSlug = 'utbildningar';
		const storySlug = pageSlug;
		return { build: { pageSlug, storySlug } };
	},
	async build(helper) {
		const token = await getAccessToken();

		await helper.fetchProps({
			courses: () => fetchAllCourses(token),
			subjects: () => fetchCustomFields('Product', 'Ämne', token),
			targetGroups: () => fetchCustomFields('Product', 'Målgrupp', token),
			educationTypes: () => fetchCustomFields('Product', 'Utbildningstyp', token),
		});

		const story = helper.result!.props.story;

		const breadcrumbs: Breadcrumb[] = [{ item: '/utbildningar', name: t`Utbildningar` }];

		helper.result!.props.config = getServerPageConfig({
			slug: helper.pageSlug,
			story,
			breadcrumbs,
		});
	},
});

export const getStaticPaths: GetStaticPaths = async () => {
	return { paths: [], fallback: 'blocking' };
};
